// core
import React from 'react';
import { Link } from 'react-router-dom'

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// shared
import PageHeader from 'components/shared/PageHeader';
import ButtonsToolbar from 'components/shared/ButtonsToolbar';
import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import SortingToolbar from 'components/shared/SortingToolbar';

import MainHeading from 'components/shared/MainHeading';
import PageDataWrapper from 'pages/shared/PageDataWrapper.js';

// page-specific/etc.
import ReactTags from 'react-tag-autocomplete';
import SchoolMainDetails from 'components/schools/SchoolMainDetails';
import TeacherDetails from 'components/teachers/TeacherDetails';

class KitOrdersEditorPage extends React.Component {
  constructor(props) {
    super(props);

    this.ABNORMAL_NUM_STUDENTS = 30;
    this.EDITABLE_STATUS = 'on_hold'; // if the status is different than this, you cannot edit
    this.IS_EDITABLE = true;

    this.state = {
      queue: {},

      kit: null,
      order: null,

      error: '',
      updateSchoolError: ''
    };

    this.handleChangeSchool = this.handleChangeSchool.bind(this);
    this.handleChangeNumStudents = this.handleChangeNumStudents.bind(this);
    this.getLocationName = this.getLocationName.bind(this);

    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    const kitId = this.props.match.params.kitId;
    if (!kitId) {
      alert('no kit ID');

      return false;
    }

    const orderId = this.props.match.params.orderId;
    if (!orderId) {
      alert('no order ID');

      return false;
    }

    // get kit
    if (this.props.appData.cache && this.props.appData.cache.kitsById[kitId]) {
        this.setState({
            kit: this.props.appData.cache.kitsById[kitId]
        });
    } else {
        this.setState({
            error: 'Kit not in cache'
        });
    }

    // get order
    this.setState((prevState) => {
      prevState.queue['get_order'] = 'Recupero ordine...';

      return prevState;
    }, () => {
      const endpoint = Settings.V3_API_URL + '/kit-orders/' + orderId;
      API.call('GET', endpoint, {},  (response, error) => {
        if (error) {
          this.setState((prevState) => {
            prevState.error = error.message + ' while getting order';
            delete prevState.queue['get_order'];

            return prevState;
          });

          return false;
        }

        if (!response.ok) {
          this.setState((prevState) => {
            delete prevState.queue['get_order'];

            prevState.error = 'Error getting order (API call failed)';

            return prevState;
          });

          return false;
        }

        this.setState((prevState) => {
          delete prevState.queue['get_order'];

          prevState.order = response.data.order;

          // let's see if the order should be editable.
          // if at least 1 item has a status different than what it should be, it's not editable
          let isEditable = true;

          if (response.data.order.items.length) {
            response.data.order.items.forEach((item) => {
              if (item.status != this.EDITABLE_STATUS && String(item.status).toUpperCase() != String(this.EDITABLE_STATUS).toUpperCase()) {
                isEditable = false;
              }
            });
          }

          prevState.IS_EDITABLE = isEditable;

          return prevState;
        });
      });
    });
  }

  handleChangeSchool(e) {
    this.setState({
      updateSchoolError: ''
    });

    const input = e.currentTarget;
    if (!input) {
      alert('no input');

      return false;
    }

    const schoolId = input.value;
    const school = this.props.appData.cache.schoolsById[schoolId];
    if (!school) {
      this.setState({
        updateSchoolError: 'Scuola non trovata'
      });
    }

    this.setState((prevState) => {
      if (school) {
        prevState.order.school = school;
      } else {
        prevState.order.school = {};
      }
      prevState.order.school.id = schoolId;

      return prevState;
    });
  }

  handleChangeNumStudents(newItem, numStudents) {
    this.setState((prevState) => {
      prevState.order.items.forEach((item, i) => {
        if (item.id == newItem.id) {
          prevState.order.items[i].schoolclass_num_students = numStudents;
        }
      });

      return prevState;
    });
  }

  getLocationName(id) {
    const location = this.props.appData.cache.locationsById[id];

    return location ? location.name : '';
  }

  handleSave() {
    this.setState((prevState) => {
      prevState.queue['save'] = 'Salvo ordine...';

      return prevState;
    });

    // first, assign school
    const order = this.state.order;
    const endpoint = Settings.V3_API_URL + '/kit-orders/' + order.id;
    const payload = {
      "teacher_first_name": order.teacher.first_name,
      "teacher_last_name": order.teacher.last_name,
      "teacher_email": order.teacher.email,
      "teacher_phone": order.teacher.phone,
      "teacher_city": order.teacher.city,
      "teacher_province": order.teacher.province,
      "teacher_subject": order.teacher.subject,

      "school_id": order.school.id,

      "user_provided_school_school_type": order.user_provided_school.type,
      "user_provided_school_name": order.user_provided_school.name,
      "user_provided_school_address": order.user_provided_school.address,
      "user_provided_school_city": order.user_provided_school.city_name,
      "user_provided_school_postcode": order.user_provided_school.postcode,
      "user_provided_school_zip_code": order.user_provided_school.zip_code, // just for compatibility
      "user_provided_school_province": order.user_provided_school.province_name,
      "user_provided_school_region": order.user_provided_school.region_name,
      "user_provided_school_phone": order.user_provided_school.phone,
      "user_provided_school_fax": order.user_provided_school.fax,
      "user_provided_school_email": order.user_provided_school.email,
      "user_provided_school_manager": order.user_provided_school.school_manager,

      "extra_value_str": order.extra_value_str,
      "extra_value_int": order.extra_value_int,

      "submitted_at": order.submitted_at
    };

    API.call('PUT', endpoint, payload,  (response, error) => {
      if (error) {
        this.setState((prevState) => {
          prevState.error = error.message + ' while saving order';
          delete prevState.queue['save'];

          return prevState;
        });

        return false;
      }

      if (!response.ok) {
        alert('Error saving order: ' + response.error);

        console.error('Error saving order');
        console.dir(response);

        this.setState((prevState) => {
          delete prevState.queue['save'];

          return prevState;
        });

        return false;
      }

      // now, save items
      this.setState((prevState) => {
        prevState.queue['save'] = 'Salvo richieste...';

        return prevState;
      });

      const numItems = this.state.order.items.length;
      let numItemsSaved = 0;
      this.state.order.items.forEach((item) => {
        console.log('Item found');
        console.dir(item);

        const endpoint = Settings.V3_API_URL + '/kit-orders/' + order.id + '/items/' + item.id;
        const payload = {
          "product_id": item.kit_id,
          "status": item.status,
          "shipped_on": item.shipped_on,
          "item_id": item.id,
          "schoolclass_schoolyear": item.schoolclass_schoolyear,
          "schoolclass_sec": item.schoolclass_sec,
          "schoolclass_num_students": item.schoolclass_num_students,
          "clone_of": item.clone_of,
          "schoolclass_type": item.schoolclass_type
        };

        API.call('PUT', endpoint, payload,  (response, error) => {
          if (error) {
            this.setState((prevState) => {
              prevState.error = error.message + ' while saving item';
              delete prevState.queue['save'];

              return prevState;
            });

            return false;
          }

          if (!response.ok) {
            alert('Error saving item: ' + response.error + ', please refresh the page');

            console.error('Error saving item');
            console.dir(response);

            this.setState((prevState) => {
              delete prevState.queue['save'];

              return prevState;
            });

            return false;
          }

          numItemsSaved++;

          if (numItemsSaved == numItems) {
            this.setState((prevState) => {
              delete prevState.queue['save'];
              prevState.just_saved = true;

              return prevState;
            });

            window.setTimeout(() => {
              this.setState((prevState) => {
                prevState.just_saved = false;

                return prevState;
              });
            }, 1000);

            // refresh report
            this.props.fetchOrdersReport(false);
          }
        });
      });

      this.setState((prevState) => {
        delete prevState.queue['save'];
        prevState.just_saved = true;

        return prevState;
      });

      window.setTimeout(() => {
        this.setState((prevState) => {
          prevState.just_saved = false;

          return prevState;
        });
      }, 1000)
    });
  }

  render() {
    if (this.state.kit && this.state.order) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>Aggiorna ordine #{this.state.order.id}</h1>

              <h2 className="mt-3 mb-3" style={{borderBottom: '1px solid #111'}}>Scuola</h2>
              <div style={{position: 'relative'}}>
                <div style={{position: 'absolute', right: 0}}>
                  <h4><i className="fa fa-pencil" /> Modifica</h4>
                  {
                    this.state.IS_EDITABLE ? (
                      <div>
                        <span className="mr-2">Codice MIUR:</span> <input className="form-control mr-2" value={this.state.order.school.id} onChange={this.handleChangeSchool} />
                        {
                          this.state.updateSchoolError != '' && (
                            <p className="text-danger"><i className="fa fa-exclamation-triangle" /> {this.state.updateSchoolError}</p>
                          )
                        }
                      </div>
                    ) : (
                      <p>NON EDITABILE (vedi stato richieste)</p>
                    )
                  }
                </div>

                {
                  this.state.order.school && this.state.order.school.id != 'N/D' ? (
                    <div>
                      {
                        !this.state.order.school.name && (
                          <img style={{position: 'absolute', width: '150px', opacity: 0.5}} src="https://i.dlpng.com/static/png/280110_preview.png" />
                        )
                      }
                      <SchoolMainDetails school={this.state.order.school} showName={true} />
                    </div>
                  ) : (
                    <div>
                      <h2 className="text-danger"><i className="fa fa-exclamation-triangle" /> Scuola non assegnata</h2>
                      <p>L'insegnante ha inserito i seguenti dati:</p>
                      <SchoolMainDetails school={this.state.order.user_provided_school} />
                    </div>
                  )
                }
              </div>

              <h2 className="mt-3 mb-3" style={{borderBottom: '1px solid #111'}}>Insegnante</h2>
              <TeacherDetails teacher={this.state.order.teacher} />

              <h2 className="mt-3 mb-3" style={{borderBottom: '1px solid #111'}}>Richieste</h2>
              {
                this.state.order.items.length && this.state.order.items.map((item) => {
                  const kit = this.props.appData.cache.kitsById[item.kit_id];
                  const schoolclassType = this.props.appData.cache.schoolclassesById[item.schoolclass_type];

                  return (
                    <div style={{position: 'relative'}}>
                      <div style={{position: 'absolute', right: 0}}>
                        <h5><i className="fa fa-pencil" /> Modifica</h5>
                        {
                          this.state.IS_EDITABLE ? (
                            <div>
                              <span className="mr-2">Numero alunni:</span>
                              <input type="number" className="form-control mr-2" value={item.schoolclass_num_students} onChange={(e) => {
                                const input = e.currentTarget;
                                if (!input) {
                                  console.error('No input found!?');

                                  return false;
                                }

                                const val = input.value;

                                return this.handleChangeNumStudents(item, val);
                              }} />
                            </div>
                          ) : (
                            <p>NON EDITABILE (vedi stato)</p>
                          )
                        }
                      </div>

                      <div>ID: {item.id}</div>
                      <div>In target: {item.shippable ? 'SI' : 'NO'} (classe in target: {item.shippable_by_schoolclass ? 'SI' : 'NO'}, località in target: {item.shippable_by_location ? 'SI' : 'NO'})</div>
                      <div>Stato: {item.status}</div>
                      <div>Kit: {kit ? kit.name : 'Sconosciuto (!?)'}</div>
                      <div>Classe: {schoolclassType.name} sez. {item.schoolclass_sec}</div>
                      <div>Numero alunni: <big>{item.schoolclass_num_students}</big> {item.schoolclass_num_students > this.ABNORMAL_NUM_STUDENTS && <span className="text-danger"><i className="fa fa-exclamation-triangle" /> troppi!?</span>}</div>
                      <hr />
                    </div>
                  );
                })
              }

              <div className="row mt-3">
                <div className="col-12">
                  <p>
                    {
                      !this.state.queue['save'] && !this.state.just_saved ? (
                        <div>
                          <button className="btn btn-success" onClick={this.handleSave}><i className="fa fa-save mr-2" /> Salva modifiche</button>
                       </div>
                      ) : ''
                    }
                    {
                      this.state.queue['save'] ? (
                        <Spinner message={this.state.queue['save']} />
                      ) : ''
                    }
                    {
                      this.state.just_saved ? (
                        <div><i className="fa fa-check text-success" /> Salvato.</div>
                      ) : ''
                    }
                    </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      let queue = Object.keys(this.state.queue).map((name) => {
        return <div><Spinner message={this.state.queue[name]} /></div>
      });

      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              {
                this.state.error && (
                    <p className="text-danger"><i className="fa fa-exclamation-triangle" /> ERRORE: {this.state.error}</p>
                )
              }
              {
                !this.state.error && (
                    <p><Spinner message="Aspetto..." /></p>
                )
              }

              {queue}
            </div>
          </div>
        </div>
      );
    }
  }
}

export default KitOrdersEditorPage;



// WEBPACK FOOTER //
// ./src/pages/kit-orders/KitOrdersEditorPage.js